/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import WebGLContext from "App/web_gl_context";
import MemoryManagement from "App/memory_management";
import Batch from "App/render/webgl/renderables/batches/batch";

export default
class BufferHandler {

    public static TypeName: string = "BufferHandler";
    protected id: WebGLBuffer = null;
    protected filledSize: number = 0;
    protected size: number = 0;
    protected bytesSize: number = 0;
    protected _typeName: string = "";
    protected _context: WebGLContext;

    constructor(aBatch: Batch) {
        this._context = <WebGLContext>aBatch.getContext();
    }

    public getWebglBuffer(): WebGLBuffer {
        return this.id;
    }

    public getClassTypeName() {
        return this._typeName;
    }

    public create() {
        this._typeName = BufferHandler.TypeName;
    }

    public reCreateBuffer(aVerticesCount, aAtributeSize) {
        this.filledSize = 0;
    }

    public bindBuffer() {
    }

    public unbindBuffer() {
    }

    public release() {
        let gl = this._context.getWebGLRenderingContext();

        if (this.id) {
            gl.deleteBuffer(this.id);
            MemoryManagement.removeBufferObject(this.bytesSize);
        }

        this.id = null;
        this.filledSize = 0;
        this.size = 0;
        this.bytesSize = 0;
    }
}
